import config from '../config';
import fetch from 'cross-fetch';
import store from 'store2';
import { addNotification as notify } from "reapop";

export function changeDueDate(data, revertFunc) {
    return (dispatch) => {
      const userAuth = store.get('user');
      if (userAuth && userAuth.api_token) {
        return fetch(`${config.apiEndpoint}/task/changeDueDate/${data.id}`, {
            body: JSON.stringify(data),
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `bearer ${userAuth.api_token}`
            },
            credentials: 'same-origin'
          })
          .then((response) => {
            return response.json();
          })
          .then(json => {
            if (json) {
              dispatch(notify({
                title: 'Update due date',
                message: 'Due date updated successfully',
                status: 'success',
                position: 'tr',
                dismissible: true,
                dismissAfter: 3000
              }));
            }
          })
          .catch(() => {
            dispatch(notify({
              title: 'Update due date',
              message: 'Due date updated failed',
              status: 'error',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000,
            }));
            revertFunc();
          })
      }
    }
}




// WEBPACK FOOTER //
// ./src/api/calendar.js